import type { AxiosError } from 'axios';
import { createMutation } from 'react-query-kit';

import { client } from '../common';

type Variables = {
  code: string;
};
export type CheckDiscountResponse = {
  amount: number;
  code: string;
};

export const useCheckDiscount = createMutation<
  CheckDiscountResponse,
  Variables,
  AxiosError
>({
  mutationFn: async (variables) =>
    client({
      url: 'v1/discounts/check',
      method: 'POST',
      data: variables,
    })
      .then((response) => response.data)
      .catch((err: any) => {
        throw new Error(err.response.data.error);
      }),
});
